"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DisplayCategoryEntity = void 0;
const swagger_1 = require("@nestjs/swagger");
const class_transformer_1 = require("class-transformer");
/**
 * Display category entity representing different types of display categories
 * in the advertising platform
 */
class DisplayCategoryEntity {
    /**
     * @deprecated
     */
    _id;
    id;
    name;
    /**
     * @deprecated
     */
    title;
    description;
    allow_adult_content;
    /**
     * @deprecated
     */
    translations;
    priority;
    baseCpm;
    business;
    is_archived;
    hide;
    stripe;
    price;
    picture_url;
    picture_name_url;
    video_url;
    number_of_displays;
    /**
     * @deprecated
     */
    update_at;
    /**
     * @deprecated
     */
    create_at;
    createdAt;
    updatedAt;
}
exports.DisplayCategoryEntity = DisplayCategoryEntity;
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Legacy (deprecated)",
        deprecated: true,
        example: "507f1f77bcf86cd799439011",
    }),
    __metadata("design:type", String)
], DisplayCategoryEntity.prototype, "_id", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Unique identifier for the display category",
        example: "507f1f77bcf86cd799439011",
    }),
    __metadata("design:type", String)
], DisplayCategoryEntity.prototype, "id", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Name of the display category",
        example: "Outdoor Billboard",
    }),
    __metadata("design:type", String)
], DisplayCategoryEntity.prototype, "name", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Title of the category (deprecated, use name instead)",
        deprecated: true,
        example: "Premium Outdoor Advertising",
    }),
    __metadata("design:type", String)
], DisplayCategoryEntity.prototype, "title", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Detailed description of the display category",
        example: "High-traffic outdoor billboard displays suitable for brand advertising",
    }),
    __metadata("design:type", String)
], DisplayCategoryEntity.prototype, "description", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether this category allows adult content",
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayCategoryEntity.prototype, "allow_adult_content", void 0);
__decorate([
    (0, class_transformer_1.Exclude)()
    /**
     * @deprecated
     */
    ,
    __metadata("design:type", Array)
], DisplayCategoryEntity.prototype, "translations", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Priority order for displaying categories (lower numbers = higher priority)",
        example: 1,
    }),
    __metadata("design:type", Number)
], DisplayCategoryEntity.prototype, "priority", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Base CPM override for displays in this category",
        example: 5,
    }),
    __metadata("design:type", Object)
], DisplayCategoryEntity.prototype, "baseCpm", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether this category is intended for business use",
        example: true,
    }),
    __metadata("design:type", Boolean)
], DisplayCategoryEntity.prototype, "business", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether this category is archived",
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayCategoryEntity.prototype, "is_archived", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Whether this category is hidden from public view",
        example: false,
    }),
    __metadata("design:type", Boolean)
], DisplayCategoryEntity.prototype, "hide", void 0);
__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Stripe payment integration configuration",
    }),
    __metadata("design:type", Object)
], DisplayCategoryEntity.prototype, "stripe", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Pricing information for this category",
    }),
    __metadata("design:type", Object)
], DisplayCategoryEntity.prototype, "price", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "URL of the category picture",
        example: "https://example.com/images/outdoor-billboard.jpg",
    }),
    __metadata("design:type", String)
], DisplayCategoryEntity.prototype, "picture_url", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Named URL for the category picture",
        example: "outdoor_billboard_category.jpg",
    }),
    __metadata("design:type", String)
], DisplayCategoryEntity.prototype, "picture_name_url", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "URL of the category promotional video",
        example: "https://example.com/videos/outdoor-billboard-promo.mp4",
    }),
    __metadata("design:type", String)
], DisplayCategoryEntity.prototype, "video_url", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Number of displays in this category",
        example: 25,
    }),
    __metadata("design:type", Number)
], DisplayCategoryEntity.prototype, "number_of_displays", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Date)
], DisplayCategoryEntity.prototype, "update_at", void 0);
__decorate([
    (0, class_transformer_1.Exclude)(),
    __metadata("design:type", Date)
], DisplayCategoryEntity.prototype, "create_at", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Creation timestamp",
        example: "2024-01-15T10:30:00Z",
    }),
    __metadata("design:type", String)
], DisplayCategoryEntity.prototype, "createdAt", void 0);
__decorate([
    (0, swagger_1.ApiProperty)({
        description: "Last update timestamp",
        example: "2024-01-15T10:30:00Z",
    }),
    __metadata("design:type", String)
], DisplayCategoryEntity.prototype, "updatedAt", void 0);
